import { S3_CONFIG } from './config/apiConfig';

type AppEnvironment = 'production' | 'development';

// ✅ Read env variable (safe + works in Vite + Amplify)
const API_URL = import.meta.env.VITE_API_URL || "";

// ✅ Derive environment from API URL
const ENV: AppEnvironment = API_URL.includes('dev')? 'development': 'production';

// ✅ Getter
export const getEnvironment = (): AppEnvironment => ENV;

// ✅ S3 keys
export const S3_KEY = ENV === 'production'? S3_CONFIG.KEY_File: S3_CONFIG.KEY_File_Dev;

export const FILE_UPLOAD_KEY = ENV === 'production'? 'PortalUploads/': 'PortalUploads/dev/';

export const S3_JSON_KEY =
  ENV === 'production'? S3_CONFIG.KEY_Dynamodb: S3_CONFIG.KEY_Dynamodb_Dev;

// ✅ Helper
export const isDevEnvironment = (): boolean => {
  console.log('Derived ENV:', ENV);
  console.log('API_URL:', API_URL);
  return ENV === 'development';
};

// ✅ Export API URL for usage
export { API_URL };
